// Copyright (c) Hamilton Manufacturing Corp.
import React from 'react';
import Title from '../../_common/form/Title';
import Card from '../Card';

const Disabled = ({ ...props }) => {
    return (
        <Card>
            <Title icon='exclamationTriangle'>Oops</Title>
            We're sorry, this feature has been disabled at this time.
        </Card>
    );
}

export default Disabled;